import moment from 'moment'

const isCurrentMonth = momentObj => {
  const endOfMonth = moment().endOf('month')
  const endOfMonthOfRequestDay = moment(momentObj).endOf('month')
  return endOfMonth.isSame(endOfMonthOfRequestDay)
}

export default {
  methods: {
    getPeriodString (fromMoment, toMoment) {
      if (!fromMoment || !toMoment) {
        return ''
      }

      if (!moment.isMoment(fromMoment)) {
        fromMoment = moment.unix(fromMoment)
      }
      if (!moment.isMoment(toMoment)) {
        toMoment = moment.unix(toMoment)
      }

      const fromString = fromMoment.format('D MMM YYYY')
      let toString = 'Present'

      if (!isCurrentMonth(toMoment)) {
        toString = toMoment.format('D MMM YYYY')
      }

      return `${fromString} - ${toString}`
    },

    generateMonthlyPeriods (fromMoment, toMoment) {
      if (!fromMoment || !toMoment) {
        return []
      }

      if (!moment.isMoment(fromMoment)) {
        fromMoment = moment.unix(fromMoment)
      } else {
        fromMoment = moment(fromMoment)
      }

      let endOfDestMonth
      if (!moment.isMoment(toMoment)) {
        endOfDestMonth = moment.unix(toMoment)
      } else {
        endOfDestMonth = moment(toMoment).endOf('month')
      }

      const periods = []
      while (!fromMoment.isAfter(endOfDestMonth)) {
        const endOfPeriod = moment(fromMoment).endOf('month')
        periods.push({
          text: this.getPeriodString(fromMoment, endOfPeriod),
          value: fromMoment.unix()
        })
        fromMoment = endOfPeriod.add(1, 'ms')
      }

      return periods.reverse()
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/datetime.js